/* Reuse the original form. This bar never creates a second cart submission. */
(() => {
  let benefitSequence = 0;
  function setupBenefitExplainers(root) {
    if (!window.HTMLDialogElement || typeof HTMLDialogElement.prototype.showModal !== 'function') return;
    root.querySelectorAll('.hmc-wide-benefits .hmc-included-benefits > .hmc-included-list > .hmc-benefit-item').forEach(item => {
      const content = item.querySelector('template[data-hmc-benefit-content]');
      const icon = item.querySelector('.hmc-icon');
      const title = item.querySelector('strong');
      if (!content || !icon || !title || item.dataset.hmcExplainerReady) return;
      item.dataset.hmcExplainerReady = 'true';
      const dialog = document.createElement('dialog');
      dialog.className = 'hmc-benefit-dialog';
      dialog.id = `${root.id}-benefit-${++benefitSequence}`;
      dialog.setAttribute('aria-modal', 'true');
      dialog.append(content.content.cloneNode(true));
      const heading = dialog.querySelector('[data-hmc-benefit-title]');
      if (!heading) return;
      heading.id = `${dialog.id}-title`;
      dialog.setAttribute('aria-labelledby', heading.id);
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'hmc-benefit-dialog-close';
      close.textContent = 'Close ×';
      close.setAttribute('aria-label', 'Close explanation');
      close.addEventListener('click', () => dialog.close());
      dialog.prepend(close);
      root.append(dialog);
      const iconButton = document.createElement('button');
      iconButton.type = 'button';
      iconButton.className = 'hmc-benefit-icon-button';
      iconButton.setAttribute('aria-label', `More information: ${title.textContent.trim()}`);
      icon.before(iconButton);
      iconButton.append(icon);
      const more = document.createElement('button');
      more.type = 'button';
      more.className = 'hmc-benefit-more';
      more.textContent = 'More info';
      more.setAttribute('aria-label', `More info about ${title.textContent.trim()}`);
      item.append(more);
      let opener;
      let previousOverflow = '';
      const triggers = [iconButton, more];
      triggers.forEach(button => {
        button.setAttribute('aria-haspopup', 'dialog');
        button.setAttribute('aria-controls', dialog.id);
        button.setAttribute('aria-expanded', 'false');
        button.addEventListener('click', () => {
          if (dialog.open) return;
          opener = button;
          previousOverflow = document.body.style.overflow;
          dialog.showModal();
          document.body.style.overflow = 'hidden';
          triggers.forEach(trigger => trigger.setAttribute('aria-expanded', 'true'));
          close.focus({preventScroll:true});
        });
      });
      dialog.addEventListener('close', () => {
        document.body.style.overflow = previousOverflow;
        triggers.forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
        opener?.focus({preventScroll:true});
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
    });
  }
  function start(root) {
    if (root.dataset.hmcCleanReady) return;
    root.dataset.hmcCleanReady = 'true';
    const purchase = root.querySelector('.hmc-product-buy-block');
    const bar = root.querySelector('.hmc-mobile-purchase');
    if (!purchase || !bar) return;
    const price = root.querySelector('#hmc-price') || root.querySelector('.price-item--regular');
    const copyPrice = () => {
      if (price) bar.querySelector('[data-hmc-sticky-price]').textContent = price.textContent.trim();
    };
    let pending = false;
    const refresh = () => {
      pending = false;
      bar.hidden = window.innerWidth >= 750 || purchase.getBoundingClientRect().bottom >= 0;
    };
    const schedule = () => {
      if (!root.isConnected || pending) return;
      pending = true;
      requestAnimationFrame(refresh);
    };
    window.addEventListener('scroll', schedule, {passive:true});
    window.addEventListener('resize', schedule);
    bar.querySelector('[data-hmc-buy-options]').addEventListener('click', () => {
      purchase.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth', block:'center'});
      const button = purchase.querySelector('[type="submit"]');
      button?.focus({preventScroll:true});
    });
    if (price) new MutationObserver(copyPrice).observe(price,{subtree:true,childList:true,characterData:true});
    copyPrice(); refresh();
  }
  const init = () => document.querySelectorAll('.hmc-clean-product').forEach(root => { setupBenefitExplainers(root); start(root); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load',init);
})();
